module.exports = __webpack_public_path__ + "static/media/shape0.pngfeat1.01e15c0c.png";